import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import PageHeader from '@/components/feature/PageHeader';
import { useSeo, siteOrigin } from '@/hooks/useSeo';
import { testimonials } from '@/mocks/site';
import AboutIntro from './components/AboutIntro';
import Principles from './components/Principles';
import ContactSection from './components/ContactSection';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      name: '关于我们 | 爆料官网',
      url: `${siteOrigin}/about`,
      description:
        '爆料官网的品牌介绍、网站定位、发展理念、内容原则、用户口碑与联系方式。',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'Organization',
      name: '爆料官网',
      url: siteOrigin,
      email: 'editor@baoliao-gw.com',
      description: '以频道列表、专题分类与内容板块组织内容的爆料资讯门户。',
    },
    {
      '@type': 'ContactPage',
      name: '联系爆料官网',
      url: `${siteOrigin}/about#submit`,
      description: '投稿爆料、内容合作与读者反馈的联系方式与在线表单。',
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: siteOrigin },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: `${siteOrigin}/about` },
      ],
    },
  ],
};

export default function About() {
  useSeo({
    title: '关于我们 | 爆料官网品牌介绍与内容原则',
    description:
      '了解爆料官网的品牌介绍、网站定位、发展理念与内容原则，查看读者口碑，并通过投稿与联系表单与编辑部取得联系。',
    keywords: '关于爆料官网,品牌介绍,网站定位,内容原则,用户口碑,联系方式',
    path: '/about',
    jsonLd: aboutJsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <PageHeader
          eyebrow="关于我们"
          title="让每一条线索，都能被清楚地讲述"
          description="爆料官网从栏目结构出发组织内容。我们认为，信息能不能被找到，和内容本身一样重要。"
          crumbs={[{ label: '关于我们' }]}
          meta={[
            { label: '内容频道', value: '10 个' },
            { label: '专题方向', value: '6 类' },
            { label: '投稿回复', value: '工作日 24h' },
          ]}
        />

        <AboutIntro />
        <Principles />

        <section className="bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
                <i className="ri-chat-quote-line" aria-hidden="true" />
                用户口碑
              </span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                读者怎么说
              </h2>
            </div>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {testimonials.map((item) => (
                <blockquote key={item.role} className="flex flex-col gap-4 rounded-lg border border-background-300/60 bg-background-50 p-5 md:p-6">
                  <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true" />
                  <p className="text-sm leading-relaxed text-foreground-700">{item.text}</p>
                  <footer className="mt-auto flex items-center gap-3 pt-3 border-t border-background-300/60">
                    <span className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-heading font-bold">
                      {item.name}
                    </span>
                    <span className="text-xs font-label text-foreground-500">{item.role}</span>
                  </footer>
                </blockquote>
              ))}
            </div>
          </div>
        </section>

        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}